import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
  .hero-slider-area {
    position: relative;
    width: 100%;
    overflow: hidden;

    .swiper-slide,
    .slider-item {
      width: 100% !important;
      height: 100%;
      flex-shrink: 0;
      position: relative;
    }

    .slider-item {
      position: relative;

      .video-container {
        width: 100%;
        height: calc(99vh - 55px);
        overflow: hidden;
        position: relative;

        video.slider-video {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
        }

        .video-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.3);
          z-index: 2;
        }

        @media (max-width: 767px) {
          height: 450px;
        }

        @media (max-width: 575px) {
          height: 360px;
        }
      }

      .slider-table {
        display: table;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9999;

        .slider-tablecell {
          display: table-cell;
          vertical-align: middle;
          text-align: center;

          .slider-title p {
            font-size: clamp(1.5rem, 4vw, 3rem);
            color: #ffffff;
            text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);
            margin-bottom: 8px;
          }

          .slider-desc h1 {
            font-size: clamp(2rem, 6vw, 5.5rem);
            color: #ffffff;
            font-weight: bold;
            text-transform: uppercase;
            text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);

            @media (max-width: 767px) {
              font-size: 26px;
            }
          }

          .slider-desc2 h1 {
            font-size: clamp(2rem, 6vw, 5.5rem);
            color: ${colors.red};
            font-weight: bold;
            text-transform: uppercase;
            text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);

            @media (max-width: 767px) {
              font-size: 26px;
            }
          }
        }
      }
    }
  }
`;
